import styled from "styled-components";

interface Props {
  name: string;
  children?: React.ReactNode;
  noPadding?: boolean;
}

const Container = styled.section<{ $noPadding?: boolean }>`
  padding: ${({ $noPadding }) => ($noPadding ? "0" : "80px 0")};

  @media (max-width: 768px) {
    padding: ${({ $noPadding }) => ($noPadding ? "0" : "60px 0")};
  }
`;

const Section = (props: Props) => {
  const { name, noPadding, children } = props;

  return (
    <Container id={name} $noPadding={noPadding}>
      {children}
    </Container>
  );
};

export default Section;
